module.exports = __webpack_public_path__ + "static/img/telephone.1733912c.png";